import * as React from 'react';
import TextInput from '@af-common/Common/_components/TextInput';
import ModuleVibranceStore from '../_stores/ModuleVibranceStore';
import { Trans } from 'react-i18next';

export type Props = {
	moduleId?: string
	vibrance?: number,
	onVibranceChange?: Function,
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class ModuleVibranceSettings extends React.Component<Props> {
	render = () => <>
		<TextInput type="number" label={<T>Vibrance</T>} onChange={this.props.onVibranceChange} value={String(this.props.vibrance)} step={0.01} min={0} max={10}/>
	</>
}